"use strict";
/*
 * Copyright (C) 2019-2021 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * HERE OMV Data source.
 *
 * @remarks
 *
 * @packageDocumentation
 */
__exportStar(require("./lib/OmvDataFilter"), exports);
__exportStar(require("./lib/VectorTileDataSource"), exports);
__exportStar(require("./lib/OmvDecoderDefs"), exports);
__exportStar(require("./lib/OmvDebugLabelsTile"), exports);
__exportStar(require("./lib/OmvRestClient"), exports);
__exportStar(require("./lib/GeoJsonDataProvider"), exports);
//# sourceMappingURL=index.js.map